import type { EntityCRUDSubject } from '../../store/types'
import { LabelRow } from './LabelRow'
import './ToolInput.css'

// Body renderer for permission_request frames with subject_kind=entity_crud —
// a household-entity CRUD mutation (create an agent / position / job
// description / …) that the initiator isn't pre-authorized for, routed to the
// owner for approval. Shares the card chrome (approve / deny / always-allow).
export function EntityCRUDBody({ subject }: { subject: EntityCRUDSubject }) {
  const who =
    subject.initiator_display ??
    (subject.initiator_kind === 'agent' ? 'An agent' : 'A member')

  return (
    <div className="tool-input">
      <div className="tool-input__text">{subject.summary}</div>
      {/* Requested-by and Action render prose and a humanized slug — nothing
          worth a clipboard. The target id is the one value you'd take
          elsewhere to look up what's about to change. */}
      <LabelRow label="Requested by" />
      <div className="tool-input__text">
        {who}
        {subject.initiator_kind === 'agent' ? ' (agent)' : ''}
      </div>
      <LabelRow label="Action" />
      <code className="tool-input__mono">{humanizeAction(subject.action)}</code>
      {subject.resource_id && (
        <>
          <LabelRow label="Target" copy={subject.resource_id} />
          <code className="tool-input__mono">{subject.resource_id}</code>
        </>
      )}
    </div>
  )
}

// "organization_position.create" -> "create organization position"
function humanizeAction(action: string): string {
  const dot = action.indexOf('.')
  if (dot < 0) return action
  const kind = action.slice(0, dot).replace(/_/g, ' ')
  const verb = action.slice(dot + 1).replace(/_/g, ' ')
  return `${verb} ${kind}`
}
